import { isIE } from './is-ie';
import styles from './google-maps-styles.json';

const addMarker = (map, mapEl, latLng) => {
  if (isIE() === false) {
    // // Colored SVG on good browsers
    const primaryColor = getComputedStyle(document.querySelector('body')).getPropertyValue('--primaryColor');
    var svgTemplate = '<svg width="25" height="40" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M8 0.75C4.33333 0.75 0.5 3.58333 0.5 8.25C0.5 12.6667 7.16667 19.4167 7.41667 19.6667C7.58333 19.8333 7.75 19.9167 8 19.9167C8.25 19.9167 8.41667 19.8333 8.58333 19.6667C8.83333 19.4167 15.5 12.6667 15.5 8.25C15.5 3.58333 11.6667 0.75 8 0.75Z" fill="' + primaryColor + '"/>' +
      '<path d="M8 10.9998C6.58333 10.9998 5.5 9.91648 5.5 8.49982C5.5 7.08315 6.58333 5.99982 8 5.99982C9.41667 5.99982 10.5 7.08315 10.5 8.49982C10.5 9.91648 9.41667 10.9998 8 10.9998Z" fill="white"/>' +
      '</svg>';
    var image = new google.maps.MarkerImage(
      "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svgTemplate)
    );
    return new google.maps.Marker({
      position: latLng,
      map: map,
      icon: image,
    });
  } else {
    // Default marker for Internet Explorer
    return new google.maps.Marker({
      position: latLng,
      map: map,
    });
  }
};

const initGoogleMaps = () => {
  const mapEl = $("#map")[0];
  let markers = [];
  if (!mapEl || (typeof google === 'undefined')) {
    return { map: {}, markers: {} };
  }
  var latitude = parseFloat(mapEl.dataset.lat) || 0;
  var longitude = parseFloat(mapEl.dataset.lng) || 0;
  const zoom = parseInt(mapEl.dataset.zoom) || 17;

  var latLng = {
    lat: latitude,
    lng: longitude,
  };

  // The map
  var map = new google.maps.Map(mapEl, {
    center: latLng,
    zoom: zoom,
    styles: styles,
  });

  // Map marker
  markers.push(addMarker(map, mapEl, latLng));

  return { map: map, markers: markers };
};

export { initGoogleMaps, addMarker };
